import React, { useState } from "react";
import { s3baseUri } from "../../../config/config";
import { useNavigate, useParams } from "react-router-dom";
import { Avatar } from "@mui/material";
import DirectContactDialog from "./DirectContactDialog";
import { useIds } from "../../../hook/AdminContext";
import CustomPopoverSection from "../../../components/menu/MebuCustomPopOverSection";
import { address_icon, email_icon } from "../../../assets";

export default function ClientsCard({
  item,
  source_slug,
  type_slug,
  isCompanyProfile = false,
  companyType = "",
  handleNavigateDetails,
  showDetailButton = true,
  additionButton = null,
  showDirectContactButton = false,
  handleEditProfile = null,
}) {
  const { userInfo } = useIds();
  const navigate = useNavigate();
  const { feature_slug } = useParams();
  const [openDirectContact, setOpenDirectContact] = useState(false);
  return (
    <>
      {openDirectContact && (
        <DirectContactDialog
          open={openDirectContact}
          handleClose={() => setOpenDirectContact(false)}
          data={item}
        />
      )}

      <div
        key={item._id}
        className="col-12 col-md-6 col-xl-4 mb-4"
        onClick={() => handleNavigateDetails(item)}
      >
        <div className="blog-card coach-card h-100 overview-coaches">
          {item?._id === userInfo?.profile_id && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                transform: "rotate(-35deg) translate(-25%, 0%)",
                height: "20px",
                minWidth: "130px",
                fontWeight: "bold",
                whiteSpace: "nowrap",
                lineHeight: "16px",
                zIndex: 1,
                fontSize: "12px",
                backgroundColor: "var(--portal-success-color)", // green success color
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0 6px",
              }}
            >
              My Profile
            </div>
          )}
          <div style={{ flexGrow: 1 }}>
            <div className="d-flex align-items-center mb-1">
              <Avatar
                src={
                  item?.profile_image?.thumbnail_2
                    ? s3baseUri + item?.profile_image?.thumbnail_2
                    : s3baseUri + item?.profile_image?.thumbnail_1
                }
                sx={{ width: 48, height: 48, mr: 1, cursor: "pointer" }}
                alt={item?.company_name}
              />
              <div className="w-100">
                <div className="d-flex align-items-start justify-content-between w-100">
                  <div>
                    <h5>{item.company_name}</h5>
                    <div className="podcast-name">
                      {item.contact_name && <span>{item.contact_name}</span>}
                    </div>
                  </div>
                  {handleEditProfile &&
                    item._id === userInfo.profile_id &&
                    ((!userInfo?.isCompanyProfile &&
                      userInfo.role == "client") ||
                      (userInfo?.isCompanyProfile &&
                        userInfo?.company_access?.manage_profile
                          ?.company_profile)) && (
                      <CustomPopoverSection
                        menu={[
                          {
                            label: "Edit Profile",
                            icon: "akar-icons:edit",
                            handleClick: () => {
                              handleEditProfile(true);
                            },
                          },
                        ]}
                        data={item}
                      />
                    )}
                </div>

                {(() => {
                  let sectorText = "";

                  // Show sectors only for the current type_slug
                  if (
                    item?.client_type?.some((sec) => sec?.slug === type_slug)
                  ) {
                    // Find the matching client_type
                    const matchingClientType = item.client_type.find(
                      (sec) => sec?.slug === type_slug
                    );

                    if (matchingClientType?.sector) {
                      // Handle both single sector object and array of sectors
                      const sectors = Array.isArray(matchingClientType.sector)
                        ? matchingClientType.sector
                        : [matchingClientType.sector];

                      sectorText = sectors
                        .map((sec) => {
                          if (sec && typeof sec === "object") {
                            return sec.title || sec.slug || "Unknown Sector";
                          }
                          return sec || "Unknown Sector";
                        })
                        .filter(Boolean)
                        .join(", ");
                    }
                  }

                  return sectorText ? (
                    <span className={`outlined-chip`}>{sectorText}</span>
                  ) : null;
                })()}
              </div>
            </div>

            <div
              className={`mt-2 text-gray description tw-line-clamp-${
                isCompanyProfile ? "2" : "3"
              }`}
              dangerouslySetInnerHTML={{
                __html:
                  isCompanyProfile && companyType
                    ? item[companyType]?.short_summary || ""
                    : item.about,
              }}
            ></div>
            <ul className="list-unstyled m-0">
              <li className="d-flex align-items-center mt-3">
                <img
                  src={email_icon}
                  alt="website_icon"
                  className="pe-2"
                  height={35}
                  width={35}
                />
                <span>{item.email}</span>
              </li>
              {isCompanyProfile && (
                <li className="d-flex align-items-center mt-2">
                  <img
                    src={address_icon}
                    alt="website_icon"
                    className="pe-2"
                    height={35}
                    width={35}
                  />
                  <span>{item.location}</span>
                </li>
              )}
            </ul>
          </div>
          <div className="row mt-3 card-action-btns">
            <div className="col-6 pe-0">
              {showDirectContactButton &&
                (userInfo.role == "client" || userInfo?.isCompanyProfile) &&
                item?.direct_contact?.email_address &&
                userInfo.profile_id !== item._id && (
                  <button
                    className="small-button w-100"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenDirectContact(true);
                    }}
                  >
                    Direct Contact
                  </button>
                )}
            </div>
            <div className="col-6 ps-0">
              {showDetailButton && (
                <button
                  className={`sm-outlined-btn !tw-px-4 tw-ms-2 w-100`}
                  onClick={(e) => {
                    e.stopPropagation();
                    // handleNavigateDetails(item);
                    if (feature_slug) {
                      navigate(`/user/${feature_slug}/${item._id}`);
                    } else {
                      navigate(`/user/${item._id}`);
                    }
                  }}
                >
                  View Profile
                </button>
              )}
            </div>

            {additionButton && additionButton}
          </div>
        </div>
      </div>
    </>
  );
}
